$(document).ready(function () {

var lastShownDate = localStorage.getItem("popup_last_shown");
  var currentDate = new Date().toDateString();

  if (lastShownDate !== currentDate) {
    // Show the popup when the user scrolls down the page
    var popupShown = false;

    $(window).scroll(function () {
      // Set the scroll threshold (e.g., 50% of the page height)
      var scrollThreshold = $(document).height() * 0.1;
      // Check if the user has scrolled past the threshold, the popup hasn't been shown yet, and it hasn't been shown today
      if ($(window).scrollTop() > scrollThreshold && !popupShown) {
        // Show the popup
        $("#popup-container").show();
        $("body").addClass("popup-overlay");
        // Set the flag to indicate that the popup has been shown
        popupShown = true;
        // Store the current date in local storage
        localStorage.setItem("popup_last_shown", currentDate);
      }
    });
  }

  // Handle button click
  $("#close-popup").on("click", function () {
    // Hide the popup
    $("#popup-container").hide();
    $("body").removeClass("popup-overlay");
    // Set the cookie to remember that the popup was hidden
    setCookie("popup_hidden", "true", 1); // 1 day
  });

  // Function to set a cookie with days instead of seconds
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Function to get a cookie by name
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /// culterra collection product slider
  $(".featured_collection_slick_slider").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  });
  /// culterra collection list slider
  $(".for-mobile-slider-").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  });
  // resizing the window for collection list
  if ($(".for-mobile-slider").length > 0) {
    $(window).resize(function () {
      $(".for-mobile-slider")[0].slick.refresh();
    });
  }

  // resizing the window collection list
  if ($(".featured_collection_slick_slider").length > 0) {
    $(window).resize(function () {
      $(".featured_collection_slick_slider")[0].slick.refresh();
    });
  }

  // $('.one-time').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   adaptiveHeight: true
  // });
  //       /// related product slider
  //       $('.related-product-slider').slick({
  //         dots: true,
  //         infinite: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         variableWidth: true,
  //         responsive: [
  //           {
  //             breakpoint: 9999,
  //             settings: 'unslick'
  //           },
  //           {
  //             breakpoint: 767,
  //             settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1,
  //               variableWidth: false,
  //             }
  //           }
  //         ]
  //       });

  var interval = setInterval(function () {
    var slider = $(".related-product-slider");

    if (slider.length) {
      console.log(slider.length);
      // Element found, initialize Slick and clear the interval
      $(".related-product-slider").slick({
        dots: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      clearInterval(interval);
    }
  }, 2000);

  // document ready function closed
});

$(".js-load-more").on("click", function () {
  var $this = $(this),
    totalPages = parseInt($("[data-total-pages]").val()),
    currentPage = parseInt($("[data-current-page]").val());
  $this.attr("disabled", true);
  $this.find("[loader]").removeClass("hide");
  currentPage = currentPage + 1;
  var nextUrl = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + currentPage);
  $("[data-current-page]").val(currentPage);
  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      $(".product-grid").append($(responseHTML).find(".product-grid").html());
    },
    complete: function () {
      if (currentPage <= totalPages) {
        $this.attr("disabled", false);
        $this.find("[load-more-text]").removeClass("hide");
        $this.find("[loader]").addClass("hide");
      }
    },
  });
});

$(function () {
  $(".product__modal-opener").click(function () {
    $(".product-media-modal").addClass("open__modal_cus");
    $(".product-media-modal").removeAttr("open");
  });
  $(".product-media-modal__toggle").click(function () {
    $(".product-media-modal").removeClass("open__modal_cus");
  });
});

// // Product slider //

// $(".product-media-modal__content").slick({
//   dots: false,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   prevArrow:
//     '<div class="left-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M602 837 c-131 -131 -172 -178 -172 -197 0 -37 334 -370 371 -370 32 0 49 17 49 49 0 20 -35 61 -147 173 l-148 148 148 148 c95 95 147 155 147 168 0 25 -30 54 -56 54 -12 0 -87 -68 -192 -173z"/></g></svg></div>',
//   nextArrow:
//     '<div class="right-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M408 984 c-8 -18 -9 -31 -2 -42 6 -9 82 -79 170 -155 87 -75 159 -142 159 -147 0 -5 -72 -70 -160 -145 -88 -75 -164 -148 -170 -161 -13 -33 4 -58 41 -62 25 -3 57 20 219 158 105 89 196 169 203 178 30 39 17 55 -188 231 -163 139 -206 171 -231 171 -22 0 -32 -6 -41 -26z"/></g></svg></div>',
// });

// // Product slider //

$(document).ready(function () {
  $(".product-media-modal__content").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<div class="left-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M602 837 c-131 -131 -172 -178 -172 -197 0 -37 334 -370 371 -370 32 0 49 17 49 49 0 20 -35 61 -147 173 l-148 148 148 148 c95 95 147 155 147 168 0 25 -30 54 -56 54 -12 0 -87 -68 -192 -173z"/></g></svg></div>',
    nextArrow:
      '<div class="right-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M408 984 c-8 -18 -9 -31 -2 -42 6 -9 82 -79 170 -155 87 -75 159 -142 159 -147 0 -5 -72 -70 -160 -145 -88 -75 -164 -148 -170 -161 -13 -33 4 -58 41 -62 25 -3 57 20 219 158 105 89 196 169 203 178 30 39 17 55 -188 231 -163 139 -206 171 -231 171 -22 0 -32 -6 -41 -26z"/></g></svg></div>',
  });

  // Bind keyboard events
  $(document).on("keydown", function (e) {
    if ($(".product-media-modal__content").hasClass("slick-initialized")) {
      if (e.keyCode === 37) {
        // Left arrow key
        $(".product-media-modal__content").slick("slickPrev");
      } else if (e.keyCode === 39) {
        // Right arrow key
        $(".product-media-modal__content").slick("slickNext");
      }
    }
  });
});



// Check if the browser is Safari on iOS or macOS
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// Check if the user agent contains "Mac OS X"
var isMacOS = navigator.userAgent.indexOf("Mac OS X") !== -1;

if (isSafari && (isMacOS || /(iPad|iPhone|iPod)/g.test(navigator.userAgent))) {
  // Add a class to the elements you want to style differently
  var elements = document.querySelectorAll(".close-icon");
  elements.forEach(function (element) {
    element.classList.add("safari-styles");
  });
}


document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('GalleryThumbnails-template--17185656799472__main');
    const prevButton = slider.querySelector('.slider-button--prev');
    const nextButton = slider.querySelector('.slider-button--next');

    // Add event listeners for keyboard navigation
    document.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        // Left arrow key pressed, simulate click on the previous button
        prevButton.click();
      } else if (event.key === 'ArrowRight') {
        // Right arrow key pressed, simulate click on the next button
        nextButton.click();
      }
    });
  });

$(document).ready(function () {
    showPopupIfUrlContainsParam();
    
    // Add event listener to close button
    $('#successclose').click(function() {
        $('#successPopupwrap').hide(); // Hide the popup
    });
});

function urlContainsParam(paramName) {
    return window.location.href.indexOf(paramName) !== -1;
}

function showPopupIfUrlContainsParam() {
    if (urlContainsParam('?customer_posted=true')) {
        document.getElementById('successPopupwrap').style.display = 'block';
    }
  $(document).on("click", function(e) {
    if ($(e.target).is("#col_dropdown_ .outer_navigation_custom_filter") === false) {
      $("#col_dropdown_").removeAttr("open");
    }
  });
}

// $(window).on('hashchange', function() {
//   if (window.location.hash === '#newsletter') {
//     $("#signup-popup-container").show();
//     $("body").addClass("popup-overlay");
//   }
// });

// $("#close-signup-popup").on("click", function () {
//     $("#signup-popup-container").hide();
//     $("body").removeClass("popup-overlay");
//     history.replaceState(null, null, window.location.pathname);
// });

